import { ConcreteEncodable } from "./ConcreteEncodable";

import { SystemMessageImplEncoder } from "../../encoder/SystemMessageImplEncoder";

import * as CubiqTS from "../../index";
import { SystemMessage } from "../SystemMessage";

export class SystemMessageImpl extends ConcreteEncodable implements SystemMessage {
  public static enType: string = "com.bcdfx.model.SystemMessageImpl";

  /*FID=1*/
  public messageType: string;
  /*FID=2*/
  public message: CubiqTS.Encodable | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SystemMessageImplEncoder.Instance;
    this.setEncodableType(SystemMessageImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SystemMessageImpl[" +
      "messageType=" +
      this.messageType +
      "message=" +
      this.message +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
